import { customAxios } from '../../_utils/axios';

// ----------------------------------------------------------------------

const deletePredictions = (
  waterQualityPredictionId: string,
  resolve: () => void,
  reject: () => void
) => {
  customAxios(
    {
      method: 'delete',
      url: 'water-quality-predictions/' + waterQualityPredictionId,
    },
    () => {
      return resolve();
    },
    () => {
      return reject();
    }
  );
};

export default deletePredictions;